/**
 * moduleHeaderConfig.js — Centralised runtime config for the global
 * header chrome (Emergency menu + module tabs) so every module can
 * plug its own settings token into the same header snippet.
 *
 * Emergency numbers are only useful on modules where users are OUT in
 * the physical world (Directory, Travel, Trip Finder). Everywhere
 * else it's noise. Modules can flip their default via a per-module
 * agency-settings toggle (see `hp_hustlemeet_settings.emergency_menu_enabled`).
 */
export const EMERGENCY_DEFAULT_HOSTS = new Set([
  "hustledirectory.au", "www.hustledirectory.au",
  "hustletravel.au", "www.hustletravel.au", "app.hustletravel.au",
  "hustlefind.au", "www.hustlefind.au",
]);

/** Host-based emergency default — true only on the whitelisted hosts. */
export function isEmergencyEnabledByHost() {
  if (typeof window === "undefined") return false;
  const h = (window.location.hostname || "").toLowerCase();
  return EMERGENCY_DEFAULT_HOSTS.has(h);
}

/** True on any HustleMeetups host (bare or app.*). */
export function isMeetupsHost() {
  if (typeof window === "undefined") return false;
  const h = (window.location.hostname || "").toLowerCase().replace(/^www\./, "");
  return (
    h === "hustlemeetups.au" || h === "app.hustlemeetups.au"
  );
}
